var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartDietPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EAFAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.2857C16 23.2857 8 18.7403 8 13.2208C8.00016 12.2452 8.33332 11.2999 8.94284 10.5454C9.55235 9.79091 10.4006 9.2739 11.3434 9.08226C12.2861 8.89062 13.2652 9.03618 14.1141 9.49419C14.9631 9.9522 15.6295 10.6944 16 11.5946L16 11.5946C16.3705 10.6944 17.0369 9.9522 17.8859 9.49419C18.7348 9.03618 19.7139 8.89062 20.6566 9.08226C21.5994 9.2739 22.4476 9.79091 23.0572 10.5454C23.6667 11.2999 23.9998 12.2452 24 13.2208C24 18.7403 16 23.2857 16 23.2857Z",
    stroke: "#348287",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartDietPlan);
export default __webpack_public_path__ + "static/media/smart-diet-plan.f6b09ab5ffc504f6e7394a1b71696547.svg";
export { ForwardRef as ReactComponent };